module.exports = __webpack_public_path__ + "static/media/what-new-banner-mobile.539ad40c.jpg";